export default __webpack_public_path__ + "static/media/background-top-right.356e541a.png";